export interface DataPurgePolicy {
  id: number;
  policyKey: string;
  retentionDays: number;
  isEnabled: boolean;
  dryRun: boolean;
  description?: string;
  modifiedDate: string;
  modifiedBy?: string;
}

export interface UpdateDataPurgePolicyRequest {
  retentionDays: number;
  isEnabled: boolean;
  dryRun: boolean;
  description?: string;
}

/** ApplicationName som Maintenance-tjenesten logger under (master ApplicationLogs). */
export const PURGE_APPLICATION_NAME = 'BizClick.WMS.MasterAdmin.Maintenance';

/**
 * Tjenesten logger også overvåking m.m. under samme ApplicationName —
 * kjørehistorikken filtrerer derfor på meldinger som starter med dette prefikset.
 */
export const PURGE_MESSAGE_PREFIX = 'DataPurge';

/** Lesevennlige etiketter for de kode-bundne policy-nøklene. */
export const POLICY_KEY_LABELS: Record<string, string> = {
  ApplicationLogs: 'Applikasjonslogg',
  StcIntRelocation: 'Relokasjoner (kun ferdig, status 100)'
};
